import {
  FETCH_ROLES,
  FETCH_ROLES_FAILURE,
  FETCH_ROLES_SUCCESS,
} from '../../constants/ActionTypes';
import { IRole } from '../../types/roles.types';
import { RolesActions } from './../../actions/RecruiterDashboard/roles.actions';

export interface IRolesState {
  roles: IRole[];
  loading: boolean;
  error: string | null;
}

const initialState: IRolesState = {
  roles: [],
  loading: false,
  error: null,
};

const rolesReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state = initialState,
  action: RolesActions
): IRolesState => {
  switch (action.type) {
    case FETCH_ROLES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_ROLES_SUCCESS:
      return {
        ...state,
        roles: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_ROLES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default rolesReducer;
